import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionUnlockPayload } from 'api/actions/revision-unlock/revision-unlock-payload';
import { RevisionUnlockPathParameters } from 'api/actions/revision-unlock/revision-unlock-path-parameters';
import { RevisionUnlockResponse } from 'api/actions/revision-unlock/revision-unlock-response';

type RevisionUnlockQueryParameters = Record<string, any>;

/**
 * The path of the RevisionUnlock action.
 */
export const revisionUnlockActionPath = new SweetPath<keyof RevisionUnlockPathParameters>(
  '/api/revision/unlock/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionUnlock actions.
 */
export default function createRevisionUnlockAction(axios: AxiosInstance) {
  return function revisionUnlockAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionUnlockPathParameters;
    query?: RevisionUnlockQueryParameters;
    payload: RevisionUnlockPayload;
  }) {
    const path = revisionUnlockActionPath.insert(parameters);

    return axios.request<RevisionUnlockResponse, RevisionUnlockResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
